<template>
  <g>
    <path
        d="M2.00333 5.88355L9.99995 9.88186L17.9967 5.8835C17.9363 4.83315 17.0655 4 16 4H4C2.93452 4 2.06363 4.83318 2.00333 5.88355Z"
        fill="currentColor"
    />
    <path
        d="M18 8.1179L9.99995 12.1179L2 8.11796V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V8.1179Z"
        fill="currentColor"
    />
  </g>
</template>

<script>
export default {
  name: "EmailIconPath"
}
</script>

<style scoped>

</style>
